module.exports = __webpack_public_path__ + "img/record_title.d198eb81.png";